<template>
  <nuttrema-layout-west-slide width="40%" minWidth="40em" >
    <west-slide-left-navigation slot="navigation-top">
      <router-link
        tag="a" activeClass="is-active" exact
        :title="$t('label.cancel')"
        :to="{ name: _get(meta, 'navigation.cancel') }">
        <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white"></nuttrema-iconica-sidebar-link>
      </router-link>
    </west-slide-left-navigation>


    <nuttrema-layout-west-three-vertical>
      <div v-if="_has(meta, 'title')" slot="top-center" class="top--center__title">
        <span>{{ $t(_get(meta, 'title')) }}</span>
      </div>
      <div slot="top-right" class="top--right__link">
        <el-popover
           width="420"
           ref="popover-options"
           trigger="click"
           placement="bottom-end"
           popper-class="el-popover--options">
          <nuttrema-layout-form-standard theme="measurements-style" class="is-auto-height">
            <el-form slot="center">
              <section class="is-options-section">
                <h4 class="section-title">{{ $t('label.options') }}</h4>
                <div class="section-items">
                  <el-form-item
                    :label="$t('label.show_all_measurements')">
                    <el-switch
                      v-model="options.showAllMeasurements">
                    </el-switch>
                  </el-form-item>
                  <el-form-item
                    :label="$t('label.preffered_input_type')">
                    <template slot="label">
                      <el-badge is-dot class="el-badge--orange-light is-right item">
                        {{ $t('label.preffered_input_type') }}
                      </el-badge>
                    </template>
                    <el-radio-group v-model="options.prefferedInputType" size="mini">
                      <el-radio-button label="percentage">{{ $t('label.percentage') }}</el-radio-button>
                      <el-radio-button label="value">{{ $t('label.value') }}</el-radio-button>
                      <el-radio-button label="both">{{ $t('label.both') }}</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <p class="section-help">
                  <el-badge is-dot class="el-badge--orange-light item"></el-badge> {{ $t('label.add_measurement_options_help') }}
                </p>
              </section>
            </el-form>
          </nuttrema-layout-form-standard>
        </el-popover>
        <el-button size="mini" type="text" v-popover:popover-options>{{ $t('label.options') }}</el-button>
      </div>

      <template slot="center">
          <nuttrema-loader v-if="PersonDetails.fetching || PersonMeasurement.fetching"></nuttrema-loader>
          <form-evolution-cred-measurement
             v-else
            :measurementID="measurementID"
            :edit="true"
            :options="options"
            :showOptions="showOptions"
            :PersonDetails="PersonDetails"
            :PersonMeasurement="PersonMeasurement"
            :period="period"
            :dateFrom="date_from"
            :dateTo="date_to"
            @submit="onSubmitFormEvent"
            @cancel="onCancelEvent"
            @done="onDoneEvent"
            @removeMeasurement="onRemoveMeasurementEvent">
          </form-evolution-cred-measurement>
      </template>
    </nuttrema-layout-west-three-vertical>


  </nuttrema-layout-west-slide>
</template>

<script>
import { mapActions } from 'vuex';
import { omitBy, isNil } from 'lodash';

import PageProps from 'components/mixins/page-props';

import { LocalStoreOptions } from 'services';
import * as KEYS from 'constants/keys';

import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';

import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';

import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import FormEvolutionCredMeasurement from './form-evolution-cred-measurement';

export default {
  name: 'page-Person-cred-measurement',
  mixins: [PageProps],
  props: {
    id: {
      required: true,
      default: null,
    },
    type: {
      required: true,
      default: null,
    },
    measurementID: {
      required: false,
      default: -1,
    },
    period: {
      type: String,
      required: false,
      default: null,
    },
    date_from: {
      type: String,
      required: false,
      default: null,
    },
    date_to: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    WestSlideLeftNavigation,
    NuttremaLayoutWestSlide,
    NuttremaIconicaSidebarLink,
    FormEvolutionCredMeasurement,
    NuttremaLayoutWestThreeVertical,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      edit: false,
      showOptions: false,
      options: {
        showAllMeasurements: false,
        prefferedInputType: 'percentage',
      },
    };
  },
  computed: {
    PersonDetails() {
      return this.$store.getters.PersonDetails(this.id);
    },
    PersonMeasurement() {
      return this.$store.getters.PersonMeasurement(this.id);
    },
    query() {
      const query = {
        period: this.period,
        date_from: this.date_from,
        date_to: this.date_to,
      };
      return omitBy(query, isNil);
    },
  },
  methods: {
    ...mapActions([
      'AddPersonMeasurement',
      'EditPersonMeasurement',
      'DeletePersonMeasurement',
    ]),
    callAddPersonMeasurement(payload) {
      this.AddPersonMeasurement({
        id: this.id,
        type: this.type,
        payload,
      }).then(() => {
        this.successNotification({ label: 'label.measurement' });
        this.onSuccessEvent();
      }).catch((error) => {
        console.error(error);
        this.errorNotification({ label: 'label.measurement' });
      });
    },
    callEditPersonMeasurement(payload) {
      this.EditPersonMeasurement({
        id: this.id,
        type: this.type,
        measurementID: this.measurementID,
        payload,
      }).then(() => {
        this.successNotification({ label: 'label.measurement' });
      }).catch((error) => {
        console.error(error);
        this.errorNotification({ label: 'label.measurement' });
      });
    },
    onSubmitFormEvent(payload) {
      if (this.measurementID !== -1) {
        this.callEditPersonMeasurement(payload);
      } else {
        this.callAddPersonMeasurement(payload);
      }
    },
    onRemoveMeasurementEvent(measurementID) {
      this.DeletePersonMeasurement({
        id: this.id,
        type: this.type,
        measurementID,
      }).then(() => {
        this.successNotification({
          message: 'message.default_success_delete_message',
          label: 'label.measurement',
        });
        this.$router.push({ name: 'participant-evolution-dashboard' });
      });
    },
    fetchPersonMeasurement() {
      this.$store.dispatch('GetPersonMeasurement', { id: this.id, type: this.type, measurementID: this.measurementID });
    },
  },
  watch: {
    options: {
      handler: (newValue) => {
        LocalStoreOptions.set(KEYS.FORM_EVOLUTION_CRED_MEASUREMENT, newValue);
      },
      deep: true,
    },
  },
  created() {
    LocalStoreOptions.get(KEYS.FORM_EVOLUTION_CRED_MEASUREMENT, this.options);
    this.fetchPersonMeasurement();
  },
  beforeDestroy() {
    this.$store.dispatch('ClearPersonMeasurementStore', { id: this.id });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/measurement/page-evolution-cred-measurement.vue